import { render } from "./ImmaginiCategorie.vue?vue&type=template&id=3336a68c&scoped=true"
import script from "./ImmaginiCategorie.vue?vue&type=script&lang=js"
export * from "./ImmaginiCategorie.vue?vue&type=script&lang=js"

import "./ImmaginiCategorie.vue?vue&type=style&index=0&id=3336a68c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3336a68c"]])

export default __exports__